import React from 'react'
import card from '../images/side-card.jpg'
function ProjectCarousal() {

  return (
    <div className=" carousals-container bg-dark ">
            <div id="mycr" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
                <div className="carousel-inner">
                    <button className="carousel-control-prev " type="button" data-bs-target="#mycr" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    {/* <!-- For Loop For Project Start --> */}
                    <div className="carousel-item active mt-5" id="project-section">

                        <div className="col-10 g-5 row justify-content-evenly mb-5">

                            <div className="col-lg-12" id="project-card">
                                <div className="card mb-3">
                                    <div className="col-12 g-0 row">


                                        <div className="col-6 col-md-5">
                                            <img src={card} alt="project"
                                                className="card-img img-fluid rounded-start" />
                                        </div>
                                        <div className="col-6 col-md-7">
                                            <div className="card-body bg-transparent d-flex flex-column">
                                                <div className="h-100">
                                                    {/* <!-- Project Title  --> */}
                                                    <h3 className="card-title mb-3">Project Name Here</h3>
                                                    {/* <!-- Project Details  --> */}
                                                    <div className="card-text">
                                                        Contrary to popular belief, Lorem Ipsum is not simply random
                                                        text.
                                                        It has roots in a piece of classical Latin literature from 45
                                                        BC,
                                                        making it over 2000 years old. Richard McClintock, a Latin
                                                        professor at Hampden-Sydney College in Virginia, looked up one
                                                        of
                                                        the more obscure Latin words, consectetur, from a Lorem Ipsum
                                                        passage, and going through the cites of the word in classical
                                                        literature, discovered the undoubtable source. Lorem Ipsum comes
                                                        from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et
                                                        Malorum" (The Extremes of Good and Evil) by Cicero, written in
                                                        45
                                                        BC. This book is a treatise on the theory of ethics, very
                                                        popular
                                                        during the Renaissance. The first line of Lorem Ipsum, "Lorem
                                                        ipsum
                                                        dolor sit amet..", comes from a line in section 1.10.32.
                                                        <br /><br />
                                                        The standard chunk of Lorem Ipsum used since the 1500s is
                                                        reproduced
                                                        below for those interested. Sections 1.10.32 and 1.10.33 from
                                                        "de
                                                        Finibus Bonorum et Malorum" by Cicero are also reproduced in
                                                        their
                                                        exact original form, accompanied by English versions from the
                                                        1914
                                                        translation by H. Rackham.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="carousel-item active mt-5" id="project-section">

                        <div className="col-10 g-5 row justify-content-evenly mb-5">

                            <div className="col-lg-12" id="project-card">
                                <div className="card mb-3">
                                    <div className="col-12 g-0 row">


                                        <div className="col-6 col-md-5">
                                            <img src={card} alt="" className="card-img img-fluid rounded-start" />
                                        </div>
                                        <div className="col-6 col-md-7">
                                            <div className="card-body bg-transparent d-flex flex-column">
                                                <div className="h-100">
                                                    {/* <!-- Project Title  --> */}
                                                    <h3 className="card-title mb-3">Project Name Here</h3>
                                                    {/* <!-- Project Details  --> */}
                                                    <div className="card-text">
                                                        Contrary to popular belief, Lorem Ipsum is not simply random
                                                        text.
                                                        It has roots in a piece of classical Latin literature from 45
                                                        BC,
                                                        making it over 2000 years old. Richard McClintock, a Latin
                                                        professor at Hampden-Sydney College in Virginia, looked up one
                                                        of
                                                        the more obscure Latin words, consectetur, from a Lorem Ipsum
                                                        passage, and going through the cites of the word in classical
                                                        literature, discovered the undoubtable source. Lorem Ipsum comes
                                                        from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et
                                                        Malorum" (The Extremes of Good and Evil) by Cicero, written in
                                                        45
                                                        BC. This book is a treatise on the theory of ethics, very
                                                        popular
                                                        during the Renaissance. The first line of Lorem Ipsum, "Lorem
                                                        ipsum
                                                        dolor sit amet..", comes from a line in section 1.10.32.
                                                        <br /><br />
                                                        The standard chunk of Lorem Ipsum used since the 1500s is
                                                        reproduced
                                                        below for those interested. Sections 1.10.32 and 1.10.33 from
                                                        "de
                                                        Finibus Bonorum et Malorum" by Cicero are also reproduced in
                                                        their
                                                        exact original form, accompanied by English versions from the
                                                        1914
                                                        translation by H. Rackham.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <button className="carousel-control-next" type="button" data-bs-target="#mycr" data-bs-slide="next">
                        <span className="carousel-control-next-icon"></span>

                        <span className="visually-hidden"> Next </span>
                    </button>
                </div>
            </div>
        </div>
  )
}

export default ProjectCarousal